import { env } from '@core/config/env';
import { getGameId, getStoredToken } from '@core/utils/auth';
import { handleApiResponse } from '@core/index';

export interface DashboardStats {
  totalOffers: number;
  runningOffers: number;
  upcomingOffers: number;
  runningOffersList: any[];
  upcomingOffersList: any[];
  syncLogs: SyncLog[];
  lastUpdated: string;
}

export interface SyncLog {
  sync_log_id: number;
  module_type: string;
  offer_name: string;
  scope: string;
  sync_status: 'success' | 'error';
  response_message: string | null;
  error_details: string | null;
  portal_endpoint: string | null;
  created_at: string;
}

export const fetchDashboardData = async (environment: 'staging' | 'prod' = 'staging'): Promise<DashboardStats> => {
  const gameId = getGameId();
  const url = `${env.apiBaseUrl}/dashboard/${environment}/${gameId}`;
  const token = getStoredToken();
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'ngrok-skip-browser-warning': '69420',
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(url, {
    method: 'GET',
    headers,
    // Include credentials if your backend needs cookies; adjust as needed
    // credentials: 'include',
  });

  return handleApiResponse<DashboardStats>(response, 'Failed to load dashboard data');
};
